import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import '../styles/vendors/lightgallery/modal-gallery.css';

import { registerComponent } from '@core/alpine-js';
import productProvider from '../components/product/productProvider';
import productGallery from '../components/product/productGallery';
import stickyBar from '../components/product/stickyBar';
import productDelivery from '../components/product/productDelivery';
import productNotify from '../components/product/productNotify';
import modalAddToCartProductSlider from '../components/product/modalAddToCartProductSlider';
import dynamicNavigation from '../components/product/dynamicNavigation';
import reviewsProduct from '../components/product/reviewsProduct';
import questionsAndAnswersItem from '../components/product/questionsAndAnswersItem';
import questionsAndAnswers from '../components/product/questionsAndAnswers';
import productInfo from '../components/product/product-info';
import productAdditionalLinks from '../components/product/product-additional-links';

registerComponent('productAdditionalLinks', productAdditionalLinks);
registerComponent('productInfo', productInfo);
registerComponent('productProvider', productProvider);
registerComponent('productGallery', productGallery);
registerComponent('stickyBar', stickyBar);
registerComponent('productDelivery', productDelivery);
registerComponent('productNotify', productNotify);
registerComponent('modalAddToCartProductSlider', modalAddToCartProductSlider);
registerComponent('dynamicNavigation', dynamicNavigation);
registerComponent('reviewsProduct', reviewsProduct);
registerComponent('questionsAndAnswersItem', questionsAndAnswersItem);
registerComponent('questionsAndAnswers', questionsAndAnswers);
